<template>
  <div class="form-group">
    <label v-if="label" class="form-label text-muted">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <select
      :disabled="readOnly"
      class="form-select form-select-lg"
      v-model="internalValue"
      :class="{ 'is-invalid': hasError }"
      @change="onChange($event)"
    >
      <option v-if="!hasDefaultValue" disabled value="">
        {{ placeholder }}
      </option>
      <option
        v-for="(item, index) in options"
        v-bind:key="'option_' + index"
        :value="item[propertyForValue]"
      >
        {{ item[propertyForText] }}
      </option>
    </select>
    <div class="invalid-feedback">
      <small>{{ errorMsg }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: {
    hasDefaultValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Aceita tanto um valor simples (String/Number) quanto um objeto vuelidate
    model: {
      required: false,
      default: null,
    },
    // Suporte para v-model
    value: {
      required: false,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    propertyForValue: {
      type: String,
      default: "id",
    },
    propertyForText: {
      type: String,
      default: "title",
    },
    label: {
      type: String,
      default: "",
    },
    errorMsg: {
      type: String,
      default: "Por favor, selecione uma opção",
    },
    placeholder: {
      type: String,
      default: "Escolha uma opção",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Detecta se é um objeto vuelidate (tem propriedade $model)
    isVuelidate() {
      return this.model && typeof this.model === "object" && "$model" in this.model;
    },
    // Valor interno que funciona tanto com vuelidate quanto com valor simples
    internalValue: {
      get() {
        if (this.isVuelidate) {
          return this.model.$model;
        }
        return this.value !== null ? this.value : this.model;
      },
      set(newValue) {
        if (this.isVuelidate) {
          this.model.$model = newValue;
        } else if (this.value !== null) {
          this.$emit("input", newValue);
        }
        // Se estiver usando :model com valor simples, não fazemos nada
        // pois o onChange já emite o evento selectChanged
      },
    },
    // Verifica se há erro (vuelidate ou prop personalizada)
    hasError() {
      return this.isVuelidate && this.model.$error;
    },
  },
  methods: {
    onChange(event) {
      this.$emit("selectChanged", event.target.value);
    },
  },
};
</script>
